/// <amd-module name="Test/ManageTestPlans/NewTestPlanPageContracts" />

export interface INode {
    id: number;
    name: string;
    guid?: string;
    structure: INodeStructureType;
    type?: number;
    children: INode[];
    parent?: INode;
    startDate?: Date;
    finishDate?: Date;
}

/** Used in INode */
export enum INodeStructureType {
    Project = 0,
    Area = 1,
    Iteration = 2
}

export interface INewTestPlanFields {
    areaPath: INode;
    iteration: INode;
    projectId: string;
    areaPathMruIds: number[];
    iterationMruIds: number[];
}

export enum ClassificationNodeTypeConstants {
    ProjectType = -42,
    AreaType = -43,
    IterationType = -44
}
export interface INodeField {
    path: string;
    node: INode;
}

/**
 * Represents the state of a form field
 */
export interface IFormFieldState<T> {
    /** Current value of the field */
    value: T;
    changed?: boolean;
    /** What is the current validation state of the field */
    validationResult: IValidationResult;
}

export interface INewTestPlanPageState{
    /** Flag indicating if the pivot is loading */
    isLoading: boolean;
    isCreatingTestPlan: boolean;
    nameField: IFormFieldState<string>;
    rootAreaPath: INodeField;
    selectedAreaPathField: IFormFieldState<INodeField>;
    rootIteration: INodeField;
    selectedIterationField: IFormFieldState<INodeField>;
    projectId: string;
    errorMessage: string;
    areaPathMruIds: number[];
    iterationMruIds: number[];
}

/**
 * Represents field validation information
 */
export interface IValidationResult {
    /** The error message, blank if valid */
    errorMessage?: string;
    /** Is the field valid? */
    isValid: boolean;
}

export class WorkItemField {
    public static workItemType: string = "System.WorkItemType";
    public static id: string = "System.Id";
    public static title: string = "System.Title";
    public static iterationPath: string = "System.IterationPath";
    public static assignedTo: string = "System.AssignedTo";
    public static workItemState: string = "System.State";
    public static areaPath: string = "System.AreaPath";
    public static systemInfo: string = "Microsoft.VSTS.TCM.SystemInfo";
    public static url: string = "url";
    public static priority: string = "Microsoft.VSTS.Common.Priority";
}
